import Navbar from "../../components/player/Navbar.tsx";
import { Outlet } from "react-router-dom";
import NavigateUserComponent from "../../components/player/NavigateUserComponent.tsx";
import "../../styles/Navigation.css";
import { usePlayerChrome } from "../../hooks/usePlayerChrome.ts";

/**
 * Represents the home page of the application.
 * It includes a navigation bar, a navigation section, sports schedule, and a schedule table.
 * @returns JSX elements representing the home page layout.
 */

const LayoutUser = () => {
    usePlayerChrome();

    return (
        <>
            <Navbar />
            <div className="custom-container grow color-pending">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <NavigateUserComponent />
                    </div>
                    <div className="col-lg-10 col-md-12">
                        <Outlet />
                    </div>
                </div>
            </div>
        </>
    );
};
export default LayoutUser;
